<template>
    <div>
        <section-header
            ref="selectHeader"
            title="Select Control Variables (Optional)"
        ></section-header>
        <analysis-variable-selection
            ref="control1Selection"
            variableType="control1"
            :title="'Include a Control Variable'"
            v-model="selectionModel.v.control1"
            v-on:variableIsSelected="selectedVariableChanged1"
            :theVariable="selectionModel.v.control1"
        ></analysis-variable-selection>
        <analysis-variable-selection
            ref="control2Selection"
            variableType="control2"
            :title="'Include an Additional Control Variable'"
            v-model="selectionModel.v.control2"
            v-on:variableIsSelected="selectedVariableChanged2"
            :theVariable="selectionModel.v.control2"
            isDependent="true"
        ></analysis-variable-selection>
        <app-navigator
            ref="appNavigator"
            :router="$router"
            nextButtonTitle="Select a variable to continue"
        ></app-navigator>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from '@/scripts/current';
import commonModelHelper from '@/scripts/commonModelHelper';
import store from '@/store';
import sectionHeader from '@/components/sub/sectionHeader';
import appNavigator from '@/components/layout/appNavigator';
import analysisVariableSelection from '@/components/analysisVariableSelection';

export default {
    components: {
        sectionHeader,
        appNavigator,
        analysisVariableSelection
    },

    data: function () {
        var vm = this;
        current.initializeCrossTabulationValues(vm);
        commonModelHelper.initializeStep(vm, 'controlvariables');
        let selectionModel = current.selectionModel;
        let omittedVariables = commonModelHelper.getSelectedVariables(
            selectionModel,
            ['row', 'column']
        );
        let control2OmittedVariables = vm.getControl2OmittedVariables();

        return {
            selectionModel,
            omittedVariables,
            control2OmittedVariables,
            isInInitialization: false
        };
    },
    mounted: function () {
        let vm = this;
        vm.isInInitialization = true;
        if (vm.$refs.control1Selection)
            vm.$refs.control1Selection.updateSelection({
                isRefresh: false,
                omittedVariables: vm.omittedVariables
            });
        if (vm.$refs.control2Selection)
            vm.$refs.control2Selection.updateSelection({
                isRefresh: false,
                omittedVariables: vm.control2OmittedVariables,
                isParentIncluded: Boolean(
                    vm.$refs.control1Selection.selectedVariableName
                )
            });
        vm.$nextTick(function () {
            vm.isInInitialization = false;
        });
    },
    methods: {
        getControl2OmittedVariables: function () {
            return commonModelHelper.getSelectedVariables(
                current.selectionModel,
                ['row', 'column', 'control1']
            );
        },
        selectedVariableChanged1: function (variable) {
            var vm = this;
            vm.selectionModel.v.control1 = variable;
            if (vm.isInInitialization) return;
            let control2OmittedVariables = vm.getControl2OmittedVariables();
            store.dispatch('selModel/setReadyForNextStep'); //todo: uncomment this
            let control1 = vm.$refs.control1Selection;

            if (vm.$refs.control2Selection)
                vm.$refs.control2Selection.updateSelection({
                    isRefresh: true,
                    omittedVariables: control2OmittedVariables,
                    isParentIncluded:
                        control1.selectedType === 'year' ||
                        control1.selectedType === 'location' ||
                        control1.selectedVariableName
                });
        },
        selectedVariableChanged2: function (variable) {
            const vm = this;
            vm.selectionModel.v.control2 = variable;
            store.dispatch('selModel/setReadyForNextStep');
        }
    }
};
</script>

<style scoped>
.spaced-out {
    margin-top: 20px;
    margin-bottom: 20px;
}

.dropdown-menu label.radio input[type='radio'] {
    visibility: hidden;
}

.dropdown-menu label.radio {
    padding-left: 10px;
}
</style>
